var map = {
	"./85off-logo-compact.svg": 8405,
	"./demo-logo-compact.svg": 24172,
	"./etrip-logo-compact.svg": 22245,
	"./findhotel-logo-compact.svg": 54405,
	"./goseek-logo-compact.svg": 42211,
	"./kayak-logo-compact.svg": 55942,
	"./kiwi-logo-compact.svg": 15189,
	"./omio-logo-compact.svg": 92530,
	"./vio-logo-compact.svg": 96038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84990;